export default __webpack_public_path__ + "static/maze-bbae66ef9391dd6fa9a51459c68a14c0.webp";